"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types = require("./types");
exports.fetchRequest = (objectType) => ({
    objectType, type: types.FETCH_REQUEST,
});
exports.fetchSuccess = (objectType, workspaceId, items) => ({
    objectType, workspaceId, items, type: types.FETCH_SUCCESS,
});
exports.fetchFailure = (objectType, errorMessage) => ({
    errorMessage, objectType, type: types.FETCH_FAILURE,
});
exports.fetchOneRequest = (objectType, objectId) => ({
    objectType, objectId, type: types.FETCHONE_REQUEST,
});
exports.fetchOneSuccess = (objectType, objectId, workspaceId, item) => ({
    objectType, objectId, workspaceId, item, type: types.FETCHONE_SUCCESS,
});
exports.fetchOneFailure = (objectType, objectId, errorMessage) => ({
    errorMessage, objectType, objectId, type: types.FETCHONE_FAILURE,
});
exports.saveRequest = (objectType, objectId) => ({
    objectType, objectId, type: types.SAVE_REQUEST,
});
exports.saveSuccess = (objectType, objectId, workspaceId, item) => ({
    objectType, workspaceId, objectId, item, type: types.SAVE_SUCCESS,
});
exports.saveFailure = (objectType, objectId, errorMessage) => ({
    errorMessage, objectType, objectId, type: types.SAVE_FAILURE,
});
exports.customRequest = (statePath) => ({
    statePath, type: types.CUSTOM_REQUEST,
});
exports.customSuccess = (statePath, workspaceId, data, reducers) => ({
    statePath, workspaceId, data, reducers, type: types.CUSTOM_SUCCESS,
});
exports.customFailure = (statePath, errorMessage) => ({
    errorMessage, statePath, type: types.CUSTOM_FAILURE,
});
//# sourceMappingURL=actions.js.map